import { SiteId } from '../../../../contexts/MenuContext/mapping.mjs';
import '../../assets/Bullet/ai-dslr.jpg.mjs';
import '../../assets/product-list-assets/cameras/bullet/ai-dslr.jpg.mjs';
import { bullet as bullet$1 } from '../product-groups/cameraSecurity/Bullet.mjs';
import { bullet } from '../product-list-groups/bullet.mjs';
import { deployment } from '../properties/deployment.mjs';
import { outdoorReady } from '../properties/outdoorReady.mjs';
import v3Image__default from "../../../../assets/ai-dslr.jpg";
import image__default from "../../../../assets/ai-dslr2.jpg";
"use strict";
const aiDslr = {
  id: "aiDSLR",
  title: "aiDSLR.title",
  techspecsPath: [SiteId.TechSpecs, `/unifi/cameras-nvrs/uvc-ai-dslr`],
  storePathParts: {
    productSlug: "uvc-ai-dslr",
    category: "cameras-bullet"
  },
  sku: "UVC-AI-DSLR",
  description: "aiDSLR.description",
  image: {
    src: image__default,
    width: 200,
    height: 140
  },
  v3Image: {
    src: v3Image__default,
    width: 250,
    height: 182
  },
  productGroup: bullet$1,
  productListGroup: bullet,
  propertyValues: [{
    propertyId: "dimensions",
    value: {
      type: "string",
      value: 'Without mount:\n\xD880 x 89 mm (\xD83.1 x 3.5")\nWith mount:\n\xD880 x 153 mm (\xD83.1 x 6")'
    }
  }, {
    propertyId: "cameraResolution",
    value: {
      type: "string",
      value: "4K"
    }
  }, {
    propertyId: "imageSensor",
    value: {
      type: "string",
      value: '4/3" 10MP CMOS'
    }
  }, {
    propertyId: "fieldOfView",
    value: {
      type: "translation",
      value: "aiDSLR.fieldOfView"
    }
  }, {
    propertyId: "nightVision",
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: "opticalZoom",
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: "smartDetections",
    value: {
      type: "boolean",
      value: true
    }
  }, {
    propertyId: "enhancedDetections",
    value: {
      type: "boolean",
      value: true
    }
  }, {
    propertyId: "licensePlateRecognition",
    value: {
      type: "boolean",
      value: true
    }
  }, {
    propertyId: "faceRecognition",
    value: {
      type: "boolean",
      value: true
    }
  }, {
    propertyId: "aiRecognition",
    value: {
      type: "boolean",
      value: true
    }
  }, {
    propertyId: "cameraAudio",
    value: {
      type: "translation",
      value: "commons.cameraAudio.twoWayAudio"
    }
  }, {
    propertyId: outdoorReady.id,
    value: {
      type: "translation",
      value: "aiDslr.outdoorReady"
    }
  }, {
    propertyId: "tamperResistance",
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: deployment.id,
    value: {
      type: "string",
      value: "PoE+"
    }
  }]
};
export { aiDslr };
//# sourceMappingURL=aiDslr.mjs.map
